/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListSetupTasksSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListSetupTasksRequest = {
  /**
   * Include hidden tasks for platform administrators.
   */
  includeHidden?: boolean | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListSetupTasksSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListSetupTasksSecurity$outboundSchema: z.ZodMiniType<
  ListSetupTasksSecurity$Outbound,
  ListSetupTasksSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSetupTasksSecurityToJSON(
  listSetupTasksSecurity: ListSetupTasksSecurity,
): string {
  return JSON.stringify(
    ListSetupTasksSecurity$outboundSchema.parse(listSetupTasksSecurity),
  );
}

/** @internal */
export type ListSetupTasksRequest$Outbound = {
  include_hidden?: boolean | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListSetupTasksRequest$outboundSchema: z.ZodMiniType<
  ListSetupTasksRequest$Outbound,
  ListSetupTasksRequest
> = z.pipe(
  z.object({
    includeHidden: z.optional(z.boolean()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      includeHidden: "include_hidden",
      gramSession: "Gram-Session",
    });
  }),
);

export function listSetupTasksRequestToJSON(
  listSetupTasksRequest: ListSetupTasksRequest,
): string {
  return JSON.stringify(
    ListSetupTasksRequest$outboundSchema.parse(listSetupTasksRequest),
  );
}
